import { createSelector } from 'reselect';
import { getIsLoading, getClassicRewardsFilter } from './propertyAvailabilitySelectors';
import { createDepositPayAvailabilityMessage } from 'lib/search/createDepositPayAvailabilityMessage';
import { getIsDomestic } from 'store/property/propertySelectors';
import { getQueryCheckIn } from './querySelectors';

export const getDepositPayAvailabilityMessage = createSelector(
  getIsLoading,
  getIsDomestic,
  getQueryCheckIn,
  getClassicRewardsFilter,
  (isLoading, isDomestic, checkIn, classicRewardsFilter) => {
    const message = createDepositPayAvailabilityMessage(isLoading, isDomestic, checkIn, classicRewardsFilter);

    return message && `Deposit Pay is ${message}.`;
  },
);
